import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

interface SearchNavigationProps {
  currentIndex: number;
  totalResults: number;
  onNavigate: (direction: 'up' | 'down') => void;
  onSelect: () => void;
  visible?: boolean;
}

const SearchNavigation: React.FC<SearchNavigationProps> = ({
  currentIndex,
  totalResults,
  onNavigate,
  onSelect,
  visible = true
}) => {
  if (!visible || totalResults === 0) return null;

  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-gray-700/50 rounded-lg border border-gray-600/30">
      <span className="text-xs text-gray-400 flex-shrink-0">
        {currentIndex + 1} de {totalResults}
      </span>
      
      <div className="flex items-center gap-1 flex-1">
        <button
          onClick={() => onNavigate('up')}
          disabled={currentIndex === 0}
          className="p-1.5 rounded hover:bg-gray-600 disabled:opacity-30 disabled:cursor-not-allowed touch-manipulation active:scale-95 transition-all"
          aria-label="Resultado anterior"
        >
          <ChevronUp className="h-4 w-4 text-gray-300" />
        </button>
        
        <button
          onClick={() => onNavigate('down')}
          disabled={currentIndex === totalResults - 1}
          className="p-1.5 rounded hover:bg-gray-600 disabled:opacity-30 disabled:cursor-not-allowed touch-manipulation active:scale-95 transition-all"
          aria-label="Próximo resultado"
        >
          <ChevronDown className="h-4 w-4 text-gray-300" />
        </button>
      </div>

      <button
        onClick={onSelect}
        className="px-3 py-1.5 bg-orange-500 hover:bg-orange-600 text-white text-xs font-medium rounded transition-colors touch-manipulation active:scale-95"
      >
        Abrir
      </button>
    </div>
  );
};

export default SearchNavigation;
